export const ROLES = {
  FOUNDER: 'founder',
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  COACHING_ADMIN: 'coaching_admin',
  COACHING_STAFF: 'coaching_staff',
  TEACHER: 'teacher',
  STUDENT: 'student',
  USER: 'user'
};

const ROLE_HIERARCHY = {
  [ROLES.FOUNDER]: 100,
  [ROLES.SUPERADMIN]: 90,
  [ROLES.ADMIN]: 80,
  [ROLES.COACHING_ADMIN]: 70,
  [ROLES.COACHING_STAFF]: 60,
  [ROLES.TEACHER]: 50,
  [ROLES.STUDENT]: 10,
  [ROLES.USER]: 5
};

export const getUserRole = (userProfile, currentUser) => {
  if (!currentUser) return ROLES.STUDENT; // Default based on test case

  if (currentUser.email === 'founder@mahstry.com') return ROLES.FOUNDER;

  if (userProfile?.role) return userProfile.role;

  if (userProfile?.isAdmin) return ROLES.ADMIN;

  if (userProfile?.coachingId) return ROLES.STUDENT;

  return ROLES.STUDENT;
};

export const isAdmin = (userProfile, currentUser) => {
  const role = getUserRole(userProfile, currentUser);
  return [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.FOUNDER].includes(role);
};

export const isTeacher = (userProfile, currentUser) => {
  const role = getUserRole(userProfile, currentUser);
  return role === ROLES.TEACHER;
};

export const isCoachingAdmin = (userProfile, currentUser) => {
  const role = getUserRole(userProfile, currentUser);
  return role === ROLES.COACHING_ADMIN || role === ROLES.COACHING_STAFF;
};

export const hasRole = (userProfile, currentUser, role) => {
  return getUserRole(userProfile, currentUser) === role;
};

export const hasMinimumRole = (userProfile, currentUser, minRole) => {
  const userRole = getUserRole(userProfile, currentUser);
  const userLevel = ROLE_HIERARCHY[userRole] || 0;
  const minLevel = ROLE_HIERARCHY[minRole] || 0;
  return userLevel >= minLevel;
};
